'use strict';

if (!Symbol.species) {
    Symbol.species = Symbol.for('@@species');
}



//////////////////
// WEBPACK FOOTER
// ./~/nmr-simulation/~/ml-matrix/src/symbol-species.js
// module id = 116
// module chunks = 0